/**
 * Normalizes operation values from the backend/URL to the UI's canonical form.
 *
 * Platform update: Backend may return "WITHDRAWAL" (withdraw flows) or "DEPOSIT" (deposit flows).
 * We support both the new values and the existing lowercase "withdraw" / "deposit" for
 * backwards compatibility. In the future, backwards compatibility can be removed once the
 * platform upgrade has been stable.
 *
 * @param value - Raw operation from /prepare response, URL params, or API
 * @returns "withdraw" | "deposit" for use in store, flow, and comparisons
 */
export function normalizeOperation(
	value: string | undefined,
): "withdraw" | "deposit" {
	const v = (value ?? "").trim().toUpperCase();
	if (v === "DEPOSIT") return "deposit";
	if (v === "WITHDRAWAL") return "withdraw";
	// Backwards compatibility: lowercase values from URL/legacy
	if (value === "deposit") return "deposit";
	if (value === "withdraw") return "withdraw";
	return "withdraw";
}
